import React, { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const NetworkStatusContext = createContext(true);

const getOnLineStatus = () =>
  typeof navigator !== "undefined" && typeof navigator.onLine === "boolean"
    ? navigator.onLine
    : true;

export const NetworkStatusProvider = ({ children }) => {
  const navigate = useNavigate();
  const [isOnline, setIsOnline] = useState(getOnLineStatus());

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      navigate(-1); // Go back to the last page
    };

    const handleOffline = () => {
      setIsOnline(false);
      navigate("/no-internet");
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [navigate]);

  return (
    <NetworkStatusContext.Provider
      value={isOnline}
      getOnLineStatus={getOnLineStatus}
    >
      {children}
    </NetworkStatusContext.Provider>
  );
};

export const useNetworkStatus = () => useContext(NetworkStatusContext);
